import { Component, Inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MutuaService } from '../services/mutua.service';
import { VentanaFlotante } from "../models/VentanaFlotante";
import { ListadoPolizasMutuaComponent } from '../listado-polizas-mutua/listado-polizas-mutua.component';

@Component({
  selector: 'ral-verificacion-mutua-dialog',
  templateUrl: './verificacion-mutua-dialog.component.html',
  styleUrls: ['./verificacion-mutua-dialog.component.scss']
})
export class VerificacionMutuaDialogComponent extends VentanaFlotante {
  protected busquedaForm = this.formBuilder.group({
    matricula: [this.data?.matricula || '', [Validators.required, Validators.minLength(5)]],
    fecha: [this.data?.fecha || '', Validators.required]
  });

  protected cargando = false;
  protected resultado: any = null;
  protected datosMutua: any = null;
  private formularioHojas: any;
  private clientes: any[];

  constructor(
    public override dialogRef: MatDialogRef<VerificacionMutuaDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: {
      taller: string,
      matricula: string,
      fecha: string,
      formularioHojas: any,
      clientes?: any[]
    },
    private formBuilder: FormBuilder,
    private mutuaService: MutuaService
  ) {
    super(dialogRef, data);
    this.formularioHojas = data.formularioHojas;
    this.clientes = data.clientes || [];
  }

  verificar() {
    if (this.busquedaForm.invalid) return;

    const { matricula, fecha } = this.busquedaForm.value;
    const tallerCodigo = this.data?.taller?.trim();

    if (!tallerCodigo) {
      this.resultado = { 
        result: false, 
        error: "El taller es obligatorio para verificar cobertura." 
      };
      return;
    }

    this.cargando = true;
    this.resultado = null;
    this.datosMutua = null;

    this.mutuaService.verificarCobertura(tallerCodigo, matricula!, fecha!).subscribe({
      next: (res) => {
        console.log("Respuesta Mutua:", res);
        if (res && typeof res === 'object' && res.poliza) {
          this.datosMutua = res;
          this.comprobarCoberturaYAdvertencias();
          this.comprobarTipoAhorroYTomador();
        }
        else if (Array.isArray(res) && res.length > 0) {
          if (res.length > 1) {
            const dialogSel = this.formularioHojas.dialog.open(ListadoPolizasMutuaComponent, {
              width: '950px',
              maxWidth: '95vw',
              height: 'auto',
              panelClass: 'custom-polizas-modal',
              data: { polizas: res }
            });

            dialogSel.afterClosed().subscribe((seleccionada: any) => {
              if (seleccionada) {
                this.datosMutua = seleccionada;
                this.comprobarCoberturaYAdvertencias();
                this.comprobarTipoAhorroYTomador();
              }
            });
          } else {
            this.datosMutua = res[0];
            this.comprobarCoberturaYAdvertencias();
            this.comprobarTipoAhorroYTomador();
          }
        }
        else {
          this.resultado = {
            result: false,
            error: "No se encontraron datos para la matrícula y fecha proporcionadas."
          };
        }
        this.cargando = false;
      },
      error: (err) => {
      console.error("Error en MUTUAWS:", err);
      this.cargando = false;

      let mensajeUsuario: string | null = null;
      if (err?.error) {
        if (err.error.detalle) {
          try {
            const detalleObj =
              typeof err.error.detalle === 'string'
                ? JSON.parse(err.error.detalle)
                : err.error.detalle;

            if (detalleObj?.detail) {
              mensajeUsuario = detalleObj.detail;
            }
            else if (detalleObj?.errorDetail) {
              mensajeUsuario = detalleObj.errorDetail;
            }
          } catch (e) {
            console.warn("No se pudo parsear detalle:", e);
          }
        }

        if (!mensajeUsuario && err.error.mensaje) {
          mensajeUsuario = err.error.mensaje;
        }

        if (!mensajeUsuario && err.error.detail) {
          mensajeUsuario = err.error.detail;
        }

        if (!mensajeUsuario && err.error.error) {
          mensajeUsuario = err.error.error;
        }
      }
      if (!mensajeUsuario) {
        if (err?.status === 0) {
          mensajeUsuario = "No se pudo conectar con el servicio de MUTUA.";
        } else if (err?.status === 500) {
          mensajeUsuario = "Error interno del servicio de MUTUA.";
        } else {
          mensajeUsuario = "Ha ocurrido un error al verificar la póliza.";
        }

      }
      this.formularioHojas.mostrarArgumentario(
        "Error en MUTUA",
        [mensajeUsuario],
        false,
        true,
        true
      );
      this.resultado = {
        result: false,
        status: err.status,
        cobertura: "SIN COBERTURA",
        errorMsg: mensajeUsuario
      };
    }
    });
  }
  guardar() {
    this.dialogRef.close(this.datosMutua || this.resultado);
  }

  //Comprobamos la cobertura y posibles advertencias.
  private comprobarCoberturaYAdvertencias() {
    
    if (this.datosMutua.tiposSiniestroPiezas && this.datosMutua.tiposSiniestroPiezas.length > 0) {
      this.resultado = { result: true, cobertura: "OK" };
    } else {
      
      this.resultado = { result: false, cobertura: "SIN COBERTURA" };
      this.formularioHojas.mostrarArgumentario(
        "Advertencia!",
        ["Sin cobertura de lunas"],
        false,
        true,
        true
      );
    }

    if (this.datosMutua.advertencias && this.datosMutua.advertencias.length > 0) {
      const advertencias = this.datosMutua.advertencias.map((a: any) => a.toString());
      this.formularioHojas.mostrarArgumentario(
          "Advertencia!",
          advertencias ,
          false,
          true,
          true
        );
      }
  }



  //Comprobamos el tipo ahorro y el tomador para posibles acciones.
  private comprobarTipoAhorroYTomador() {
  
    const tipoAhorro = this.datosMutua.poliza?.tipoAhorroIVA?.toString().trim() || '';
    const cifTomador = this.datosMutua.poliza?.tomador?.documento?.trim() || '';
    const nombreTomador = this.datosMutua.poliza?.tomador?.nombre?.trim() || '';

    // Limpieza inicial
    this.formularioHojas.llamada.observ = '';
    this.formularioHojas.mensajeObser = '';

    if (!tipoAhorro) return;

    console.log(`Analizando tipoAhorroIVA: ${tipoAhorro}`);
    this.formularioHojas.mensajeObser =
      (this.formularioHojas.mensajeObser || '') + `\n${tipoAhorro}`;

    const esClienteAbonaEXT = tipoAhorro.includes(
      "El cliente debe abonar la factura antes de retirar el vh del taller"
    );
    
    const esSantander = tipoAhorro.includes("El Banco de Santander pagará al taller");

    // ============================================
    // CASO EXT (Cliente abona factura)
    // ============================================
    if (esClienteAbonaEXT) {
      
      this.formularioHojas.cambioCompaniaAutomatica = true; // Esto es para que al cambiar el cliente no vuelva a salir POPUP de verificar.
      const listaCias = this.formularioHojas?.cias || [];

      const clienteEncontrado = listaCias.find((c: any) => {
        const dnicif = (c?.dnicif || '').toString().trim().toUpperCase();
        const buscar = cifTomador.toUpperCase();
        return dnicif === buscar;
      });

      if (clienteEncontrado && cifTomador) {
        this.formularioHojas.auxCia = clienteEncontrado.cliente;
        this.formularioHojas.changeCia();
        console.log(`Compañía actualizada al cliente con NIF ${cifTomador}`);
      } else {
        this.formularioHojas.auxCia = "144442";
        this.formularioHojas.changeCia();
        console.log("Cliente no encontrado por NIF → cargada compañía por defecto 144442");
      }
    }

    // ============================================
    // CASO BANCO SANTANDER
    // ============================================
    if (esSantander) {
      const codigoCompaniaSantander = "135486";
      const nombreCompaniaSantander = "BANCO SANTANDER, S.A. (MMA)";
      this.formularioHojas.cambioCompaniaAutomatica = true;

      if (this.formularioHojas.onCiaSeleccionadoChange) {
        this.formularioHojas.ciaSeleccionada = {
          cliente: codigoCompaniaSantander,
          nombre: nombreCompaniaSantander
        };
        this.formularioHojas.onCiaSeleccionadoChange(this.formularioHojas.ciaSeleccionada);
      }

      this.comprobarSiniestroYNotificar();
    }

    // ============================================
    // NUEVO BLOQUE: Añadir datos del tomador SIEMPRE
    // ============================================
    if (nombreTomador || cifTomador) {
      const observacionTomador = `TOMADOR: ${nombreTomador || 'SIN NOMBRE'} — NIF: ${cifTomador || 'SIN NIF'}`;
      this.formularioHojas.mensajeObser =
        (this.formularioHojas.mensajeObser || '') + `\n${observacionTomador}`;
      console.log("Añadida observación con datos del tomador:", observacionTomador);
    }
}

  //Comprobamos si tiene siniestro o no, ascoiado / SOLO PARA BANCO SANTANDER.
  private comprobarSiniestroYNotificar() {
    
    const tieneSiniestro =
      Array.isArray(this.datosMutua?.siniestros) && this.datosMutua.siniestros.length > 0;

    if (!tieneSiniestro) {
      // Mostrar solo el aviso
      this.formularioHojas.mostrarArgumentario(
        "Aviso MUTUA",
        [
          "Tienes que comunicar al cliente que tiene que conseguir el número de referencia / expediente antes de acudir a la cita del taller"
        ],
        true,   // mostrarBtnAceptar
        true,   // mostrarBtnCancelar
        true    // disableClose (obliga a leer)
      );
    }
  }

}